export {AdminTable} from "./AdminTable";
export type {AdminTableProps} from "./AdminTable";
